import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loginUser } from "../../actions/authActions";
import classnames from "classnames";
import SessionDataStore from "../../streaming/SessionDataStoreController";
import Util from "../../streaming/Util";
import { Link } from 'react-router-dom';

import $ from 'jquery';

import SupportContainer from '../home/SupportContainer';

/***CHECK FOR OUR BROWSER TYPE AND OSNAME  START HERE*/
import { isChrome as chrome, isSafari as safari, isMobileOnly as mobileOnly, isTablet as tablet, isAndroid as android, isIOS as ios,isFirefox as ff, isIE as ie,isEdge as edge, osName as osname,fullBrowserVersion as fbrowserversion, browserName, mobileVendor as mobvendor, deviceType, isIPad13 as ipad13} from "react-device-detect";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email:"",     
      password:"",
      type:"1",
      errors: {},
      redirectRouting:'',
      firstName:'',
      show_loader:false,
      showPassword: false,
	  supportPageName: 'Login',
	  supportPageApi: '/login',
	  userTypeFaqs: 1
    };

    this.sessionDataStore = SessionDataStore.getInstance();
  }

  
  componentDidMount() {
    localStorage.removeItem('sessionData');
    localStorage.removeItem('deeplinkRef');
    localStorage.setItem("remindLog", true);
    $('#email').on('focus', function() {
        document.body.scrollTop = 200;    
    });

    // If logged in and user navigates to Login page, should redirect them to dashboard
    if (this.props.auth.isAuthenticated) {

        var localstoragedata = JSON.parse(localStorage.getItem('userData'));
        const userData = {
            userId: localstoragedata.id,
            auth: localstoragedata.token
        };
        this.props.loginUser(userData);

        $('.main_loader').attr({'style':'display:flex'});
    } else {

        setTimeout(() => {
          console.log('electron deeplinking params - ', window['deeplinkingParams']);

    		  if ( window['electron'] && window['deeplinkingParams'] == undefined )
    			{
    				var mainThis = this;
    				window['fillLogin'] = function ()
    					{
    						if ( localStorage.getItem('electronData') )
    							{
    								try
    									{
    										var elJSON = JSON.parse(localStorage.getItem('electronData'));
    										
    										if ( elJSON['chkbx'] && elJSON['chkbx'] !== '' && elJSON['email'] !== '' )
    											{
    												$('#remember_me').attr('checked', 'checked');
    												
    												mainThis.setState({
    													email: elJSON['email']
    												});
    											}
    										else
    											{
    												$('#remember_me').removeAttr('checked');
    												
    												mainThis.setState({email:'', password: ''});
    											}
    									}
    								catch (er)
    									{
    										console.log(er);
    										$('#remember_me').removeAttr('checked');
    										mainThis.setState({email:'', password: ''});
    								} 
    							}
    					}
    				

            if ( localStorage.getItem('userData') !== null )
            {
                var localstoragedata = JSON.parse(localStorage.getItem('userData'));

                const userData = {
                    userId: localstoragedata.id,
                    auth: localstoragedata.token
                };
                this.props.loginUser(userData);

                $('.main_loader').attr({'style':'display:flex'});
            }
            else
            {
                window['fillLogin']();
            }
    			}
    		else
    			{
    			
    				  if (localStorage.getItem('chkbx') && localStorage.getItem('chkbx') !== '' && localStorage.getItem('email') !== '' && localStorage.getItem('password_remember') &&  localStorage.getItem('password_remember') !== '') {
    					  $('#remember_me').attr('checked', 'checked');
    					  this.setState({
    							email: localStorage.getItem('email')
    						  })
    				  } else {
    					  $('#remember_me').removeAttr('checked');
    					  this.setState({
    							email:'', 
    							password: ''})
    				  }
    			}
      }, 1000);
    }

    localStorage.removeItem("video-resolution");
    localStorage.removeItem("showMicrophoneAlert");
	

	  console.log('system', osname, chrome, fbrowserversion);
	  
    /****CHECK OSNAME BROWSER IF MOBILE OR TABLET */
    if(osname=="iOS" && ios==true && ipad13 == false){
      $("#virdio_onboarding1").removeClass('d-none');
      $("#login-container").addClass('d-none');
    }

    if(osname == "Android" && android == true && tablet == false) {
      $("#virdio_onboarding1").removeClass('d-none');
      $("#login-container").addClass('d-none');
    }

    if(mobileOnly === false && tablet === true && osname=="Mac OS") {
        window['ipad'] = true;
    }

    if(osname=="Windows" || osname=="Linux" || osname=="Ubuntu" || osname=="Mac OS"){ 
        if((ff==true) && (parseFloat(fbrowserversion) < 72) && !window.electron){
          {$("#virdio_onboarding1").addClass('d-none')};
          {$("#virdio_onboarding6").removeClass('d-none')};
        }
        if((chrome==true) && (parseFloat(fbrowserversion) < 79) && !window.electron){
          {$("#virdio_onboarding1").addClass('d-none')};
          {$("#virdio_onboarding6").removeClass('d-none')};
        }
        if((edge==true) && (parseFloat(fbrowserversion) < 78) && !window.electron){
          {$("#virdio_onboarding1").addClass('d-none')};
          {$("#virdio_onboarding6").removeClass('d-none')};
        }
        if (ie && !window.electron) {
          {$("#virdio_onboarding1").addClass('d-none')};
          {$("#virdio_onboarding6").removeClass('d-none')};
        }
        if (safari && (parseFloat(fbrowserversion) < 13) && !window.electron) {
          {$("#virdio_onboarding1").addClass('d-none')};
          {$("#virdio_onboarding6").removeClass('d-none')};
        }
    }
    
    if(osname == "iOS" && safari && parseInt(fbrowserversion) < 13)
    {
      {$("#virdio_onboarding1").addClass('d-none')};
      {$("#virdio_onboarding6").removeClass('d-none')};
    }

    if(osname=="Android" || deviceType=="mobile" && mobvendor=="Google"){
      this.setState({
        redirectRouting:"https://play.google.com/store/apps/details?id=mvvm.f4wzy.com.virdioApp"
      })
    }
    if(osname == "iOS" || deviceType == "mobile" && mobvendor == "Apple"){
      this.setState({
        redirectRouting:"https://apps.apple.com/us/app/virdio/id1489704718"
      })
    }

    if (this.props.match.params.err !== undefined) {
      console.log('ERROR OLD---', this.props.match.params.err);
	  $('#login-alert-text').text(this.props.match.params.err);
      {$("#login-alert").attr({'style':'display:block'})};
    }
  }

	componentWillReceiveProps(nextProps) {
		this.setState({show_loader:false});
		$('.main_loader').hide();

		if (nextProps.auth.isAuthenticated) 
			{
				var localstoragedata = JSON.parse(localStorage.getItem('userData'));

				if(localstoragedata && localstoragedata.onDemandData && localstoragedata.onDemandData.ondemandId != undefined && !localstoragedata.hasLiveAndOnDemand )
					{
						let addObject = {"sessionId": localstoragedata.onDemandData.ondemandId , "event": "status", "eventType": "login", "userId": localstoragedata.id, "details": JSON.stringify({"status":"success"}), "timestamp": Util.getCurrentTimestamp()};
						this.sessionDataStore.addSessionData(addObject);

						if (localstoragedata.onDemandData.ondemandId != undefined) 
							{
								var storage = JSON.parse(localStorage.getItem('userData'));
								storage.sessionData = JSON.parse(JSON.stringify(storage.onDemandData));
								localStorage.setItem("userData", JSON.stringify(storage));
								console.log('ondemand1');
								this.props.history.push("/pre-screen");
							} 
						else 
							{
								this.props.history.push("/pre-screen");
							}
					} 
				else if(localstoragedata && localstoragedata.sessionData && ( localstoragedata.sessionData.id != undefined ) && !localstoragedata.hasLiveAndOnDemand )
					{
						let addObject = {"sessionId": localstoragedata.sessionData.id, "event": "status", "eventType": "login", "userId": localstoragedata.id, "details": JSON.stringify({"status":"success"}), "timestamp": Util.getCurrentTimestamp()};
						this.sessionDataStore.addSessionData(addObject);
						if ( window['deeplinkingParams'] !== undefined )
							{
								this.props.history.push("/pre-screen");
							}
						else
							{
								this.props.history.push("/home#mySchedule");
							}
					}	  
				else 
					{
						if ( localstoragedata.sessionData != undefined && !localstoragedata.hasLiveAndOnDemand ) 
							{
								let mainSessionArray;
								if ( localstoragedata.sessionData && localstoragedata.sessionData.length > 0 )
									{
										let sortedSessionData = localstoragedata.sessionData.sort(Util.sortByDate);
										mainSessionArray = sortedSessionData[0]
									}
								else
									{
										mainSessionArray = localstoragedata.sessionData;
									}


								let joinDuration = localstoragedata.default.streamJoiningDefaultTime * 60000;
								var startDateTime = new Date(new Date(mainSessionArray.scheduleDate).getTime() - joinDuration);
								var timeLeft = Math.ceil(Math.round( (new Date(startDateTime).getTime() - new Date().getTime()) / 1000 ) / 60 );
								console.log('timeLeft - ', timeLeft);
								console.log('deeplinkingParams - ',  window['deeplinkingParams']);

								if ( timeLeft <= 0 && window['deeplinkingParams'] !== undefined && localstoragedata.totalSession < 2 )
									{
										localstoragedata.sessionData = mainSessionArray;
										localStorage.setItem("userData", JSON.stringify(localstoragedata));
										this.props.history.push("/pre-screen");
									}
								else
									{
										this.props.history.push("/home");
									}
							}
						else
							{
								this.props.history.push("/home");
							}
					}
			}

		if (nextProps.errors && Object.keys(nextProps.errors).length > 0) 
			{
				$('#login-alert-text').text(nextProps.errors);
				{$("#login-alert").attr({'style':'display:block'})};

				let addObject = {"sessionId": 1, "event": "error", "eventType": "login", "details": JSON.stringify({"email": $("#email").val(), "status":"fail", "msg":nextProps.errors}), "timestamp": Util.getCurrentTimestamp()};
				this.sessionDataStore.addSessionData(addObject);
				this.sessionDataStore.dumpData();
			}
  }

  onChange = e => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleChange= e => {
    this.setState({type: e.target.value});
  };

  onSubmit = e => {
    e.preventDefault();

    const userData = {
      email: this.state.email,
      password: this.state.password,
      type: this.state.type
    };

    this.setState({show_loader:true});
    this.props.loginUser(userData); // since we handle the redirect within our component, we don't need to pass in this.props.history as a parameter
  };
  
closePopup(){
    $('#login-alert-text').text('');
    {$("#login-alert").attr({'style':'display:none'})};
}

canBeSubmitted() {
  const { email, password } = this.state;
  return (
    email.length > 0 &&
    password.length > 0
  );
}

showHidePassword = (e) => {
  if (this.state.showPassword === false) {
      this.setState({showPassword: true});
  } else {
      this.setState({showPassword: false});
  }
}

deeplinking = () => {

    if (window['deeplinkingParams'] !== undefined) {
        let userId = window['deeplinkingParams'][0].split('=')[1];
        let tokenData = window['deeplinkingParams'][1].split('#')[0];
        let userToken = tokenData.split('=')[1];

        const userData = {
            userId: userId,
            auth: userToken
        };

        if (window['deeplinkingParams'][2] !== undefined) {
            let param2 = window['deeplinkingParams'][2].split('=');
            if ( param2[0] == 'ondemandId' )
            {
                // userData.onDemandId = window['deeplinkingParams'][2].split('=')[1];
                userData.onDemandId = param2[1];
            }
            else
            {
                localStorage.setItem('deeplinkRef', param2[1].split('#')[0]);
            }
        }

        console.log('deeplinking received ===== prepared data -- ', userData);

        this.setState({show_loader:true});
        this.props.loginUser(userData);
    }
}

render() {
  const { errors } = this.props;
  const isEnabled = this.canBeSubmitted();

  return (
      <div className="container">
        <div className="row">
          <div className="login-bg" id="login-container">
            <div className="login-box">
              <div className="col-md-7 col-lg-5 col-sm-6 text-light mx-auto">
              
              <div className="col-12">
                <img src="./images/login-logo.png" className="login-logo" />
                <p className="login-tagline">Login and Join a Virtual Studio</p>
              </div>
              <form className = "form-horizontal pt-1" role = "form"  noValidate onSubmit={this.onSubmit} autoComplete="off">
              
                <div className="login-inner">
                <div className = "form-group pb-3 mb-0 mt-4">
                    {/* <span className="text-danger">{Object.entries(errors).length > 0 && errors}</span>*/}
                    <label>Enter your email address</label>
                    {/*<input autoFocus type="email"  id="email" onChange={this.onChange} value={this.state.email}  error={Object.entries(errors).length > 0 && errors}  className={classnames("", { invalid: Object.entries(errors).length >0 && errors })} className = "form-control"  />*/}
                    <input autoFocus type="email"  id="email" onChange={this.onChange} value={this.state.email} className = "form-control"  />
                  <img src="./images/login-user.png" className="user-login" />
                </div>

                <div className = "form-group mt-4 mb-0">
                    <label>Password</label>
                    <input type={this.state.showPassword === true ? 'text' : 'password'}  id="password" onChange={this.onChange} value={this.state.password} className = "form-control"/>
                    <img src={this.state.showPassword === true ? './images/eye-slash.png' : './images/eye.png'} className="user-login" id="password-img" onClick={this.showHidePassword.bind(this)} />
                </div>
                
                <div className = "form-group mt-4 mb-0 pl-0">
                <div className="custom-control custom-checkbox">
                  <input type="checkbox" className="custom-control-input" value="remember-me" id="remember_me" name="example1" />
                    <label className="custom-control-label" htmlFor="remember_me">Remember me</label>
                  </div>
                </div>
      
                <div className = "form-group pt-3 mb-4">
                    <div className = "d-flex flex-wrap justify-content-between align-items-center">
                    
                      {/*<button type = "button" className="btn-cancel btn btn-large btn-outline-secondary waves-effect waves-light hoverable blue accent-3 rounded p-3 px-4">Cancel</button>*/}
                      <div className="d-flex align-items-center">
                        <button disabled={!isEnabled} type = "submit" className="btn-login btn btn-large btn-primary waves-effect waves-light hoverable blue accent-3 p-3 px-4 rounded">Login</button>
                        <div className={classnames({'circle':true, 'mx-3':true, 'd-none':!this.state.show_loader})}></div>
                      </div>
				              <Link to="/forgot-password" className="open-list forgot-password mt-sm-0 mt-3">Forgot password?</Link>
                    </div>
                </div>
                
              </div>
            </form> 
            <span id="deeplinkold" onClick={this.deeplinking.bind(this)}></span>
            </div>
            </div>
            <a href="privacy-policy.html" target="_blank" className="privacy-link">Click to view the virdio privacy policy</a>
          </div>
          
        </div>

      {/*******ADD OPEN POPUP FOR CHECK BROWSER AND OS COMPITABLITY START HERE */}
      <div className="onboarding-screen pr-0 model onboarding-modal d-none" id="virdio_onboarding1">       
            <div className="modal-dialog width-75 mx-auto modal-dialog-centered">
                <div className="modal-content px-md-5 py-3 position-relative radius-10">
                    {/* <button type="button" className="close white close-btn1" data-dismiss="modal">×</button> */}
                    <div className="modal-body mx-0 mx-md-4 pb-md-4 shadow-none round">
                      <h4 className="modal-title text-white text-center font-35 font-medium mb-2 mb-md-4">Virdio</h4> 
                     
                      <p className="text-white font-24 text-center px-sm-4">Please click on the button below to download the Virdio Mobile App, which can be used to stream the class or as the Virdio Remote Control App.</p>
                      <div className="text-center mt-3 mt-md-5">
                                             
                       <button type="button" className="custom_btn11 mt-3 mx-3" data-toggle="modal" onClick={e=>{window.location.assign(this.state.redirectRouting)}}>Download Mobile App</button>
                      </div>
                      {/* <div className="pt-4 pt-md-5 pb-3 mt-2 mt-sm-4 mt-md-5">
                        <button type="button" className="gray-btn py-2 px-4" data-toggle="modal" data-target="#virdio_onboarding5">Learn More</button>
                      </div>  */}
                    </div>                        
                    </div>
                </div>
            </div> 
            {/**CHECK BLROWSER TYPE MESSAGE **/}
            <div className="onboarding-screen pr-0 model onboarding-modal d-none" id="virdio_onboarding6">       
            <div className="modal-dialog width-75 mx-auto modal-dialog-centered">
                <div className="modal-content px-md-5 py-3 position-relative radius-10">
                    {/* <button type="button" className="close white close-btn1" data-dismiss="modal">×</button> */}
                    <div className="modal-body mx-0 mx-md-4 shadow-none round">
                      <h4 className="modal-title text-white text-center font-35 font-medium mb-1">Virdio</h4> 
                      {/* <p className="text-white font-24 text-center px-sm-4 d-none">Hi {this.state.firstName}, Please confirm that you are going to use this device, OS- {osname} {version}, Browser- {browserName} {fbrowserversion}, for attending the class?</p> */}
                      <p className="text-white font-24 text-center px-sm-4">Your Browser is not supported by Virdio. For better experience, we recommend you to use any of the following:</p>
                      <table className="table table-bordered text-white ">
                      <tr>
                          <td>MacBook/iMac</td>
                          <td><a href="https://apps.apple.com/us/app/virdio/id1489704718" target="_blank">Virdio App</a> | <a href="https://support.apple.com/downloads/safari" target="_blank">Safari</a> - v 13 + | <a href="https://www.google.com/chrome/" target="_blank">Chrome</a> - v 79 + | <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a> - v 72 +</td>
                        </tr>
                        <tr>
                          <td>Windows 10 </td>
                          <td><a href="https://www.google.com/chrome/" target="_blank">Chrome</a> - v 78 + | <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a> - v 72 +| <a href="https://www.microsoft.com/en-us/edge" target="_blank">Edge</a> - v 79 +</td>
                        </tr>
                        <tr className="text-white">
													<td>iOS</td>
													<td><a href="https://apps.apple.com/us/app/virdio/id1489704718" target="_blank">Virdio App</a></td>
												</tr>
                        <tr className="text-white">
													<td>Android</td>
													<td><a href="https://play.google.com/store/apps/details?id=mvvm.f4wzy.com.virdioApp&hl=en" target="_blank">Virdio App</a></td>
													</tr>
                          <tr className="text-white">
													<td>Linux</td>
													<td><a href="https://www.google.com/chrome/" target="_blank">Chrome</a> - v 78 + | <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a> - v 72 +| <a href="https://www.microsoft.com/en-us/edge" target="_blank">Edge</a> - v 79 +</td>
													</tr>
                      </table>
                      {/* <p className="text-white">Quick Instalation  links: <a href="https://www.google.com/chrome/">Chrome</a> | <a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a> | <a href="https://www.microsoft.com/en-us/edge">Edge</a> <br /><br />Alternatively you can also dowload Virdio Mobile apps from marketplaces @  <a href="https://apps.apple.com/us/app/virdio/id1489704718"><b>iOS</b></a> | <a href="https://play.google.com/store?hl=en"><b>Android</b> </a></p> */}
                      {/* <p className="text-white">Alternatively you can also dowload Virdio Mobile apps from marketplaces @  <a href="https://apps.apple.com/us/app/virdio/id1489704718"><b>iOS</b></a> | <a href="https://play.google.com/store?hl=en"><b>Android</b> </a></p> */}
                      <div className="text-center mt-3 mt-md-5 d-none">
                        <button type="button" className="custom_btn11 mt-3 mx-3" onClick={e=>{window.location.assign(this.state.redirectRouting)}}>yes</button>
                        <button type="button" className="custom_btn11 mt-3 mx-3" data-toggle="modal" data-target="#verdio_onboard">no</button>
                      </div>
                       <div className="pt-4 mt-2">
                        {/*<button type="button" className="gray-btn py-2 px-4" data-toggle="modal" data-target="#virdio_onboarding5">Learn More</button>*/}
                      </div>  
                    </div>                        
                    </div>
                </div>
            </div> 
            <div id="login-alert" className="modal bg-transparent" data-backdrop="static" data-keyboard="false">
              <div className="modal-dialog modal-confirm modal-dialog-centered">
                <div className="modal-content bg-transparent position-relative">
                  <div className="modal-body px-4 py-4 py-md-5 bg-grayy radius-10">
                    <h5 className="text-center white_hdng font-30 mb-4">Virdio</h5>
                    <div>
                      <p className="text-white text-center font-20 mb-4" id="login-alert-text"></p>
                    </div>
                  </div>
                  <div className="text-center" id="startedsessionok">
                    <button className="ok-btn mt-3" onClick={this.closePopup.bind(this)}>OK</button>
                  </div>
                </div>
              </div>
            </div>
            {/***END HERE***/}

            <div className="main_loader">
              <div className="main_loader_inner"></div>
            </div>
			
			<SupportContainer supportPageName={this.state.supportPageName} supportPageApi={this.state.supportPageApi} userTypeFaqs={this.state.userTypeFaqs}></SupportContainer>
      </div>
    );
  }
}

Login.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { loginUser }
)(Login);